// eslint-disable-next-line import/no-cycle
import feathersClient from '../../feathers-client';

const defaultRightToWorkRequestsPagination = {
	total: 100,
	$skip: 0,
	$limit: 4,
};

const defaultRightToWorkRequestsFilter = {
	$skip: defaultRightToWorkRequestsPagination.$skip,
	$limit: defaultRightToWorkRequestsPagination.$limit,
};

export default {
	state: {
		rightToWorkRequests: [],
		rightToWorkRequestsFilter: defaultRightToWorkRequestsFilter,
		rightToWorkRequestsPagination: defaultRightToWorkRequestsPagination,
		currentStatusPage: '',
		requestId:''
	},
	getters: {
		rightToWorkRequestsPage: (state) => {
			const { $limit, $skip } = state.rightToWorkRequestsPagination;
			return $skip / $limit + 1;
		},
	},
	mutations: {
		SET_CURRENT_STATUS_PAGE: (state, currentStatusPage) => { state.currentStatusPage = currentStatusPage; },
		SET_RIGHT_TO_WORK_REQUESTS: (state, rightToWorkRequests) => { state.rightToWorkRequests = rightToWorkRequests; },
		SET_RIGHT_TO_WORK_REQUESTS_PAGINATION: (state, data) => { state.rightToWorkRequestsPagination = { ...state.rightToWorkRequestsPagination, ...data }; },
		SET_RIGHT_TO_WORK_REQUESTS_FILTER: (state, filter) => { state.rightToWorkRequestsFilter = { ...state.rightToWorkRequestsFilter, ...filter }; },
		SET_DEFAULT_RIGHT_TO_WORK_REQUESTS_FILTER: (state, filter) => { state.rightToWorkRequestsFilter = { ...filter, ...defaultRightToWorkRequestsFilter }; },
		SET_REQUEST_ID:(state, currentRequestId) => { state.requestId = currentRequestId; },
	},
	actions: {
		setCurrentStatusPage: ({ commit }, status) => {
			commit('SET_CURRENT_STATUS_PAGE', status);
		},
		setRightToWorkRequestsFilter: ({ commit }, filter) => {
			commit('SET_RIGHT_TO_WORK_REQUESTS_FILTER', filter);
		},
		setDefaultRightToWorkRequestsFilter: ({ commit }, filter) => {
			commit('SET_DEFAULT_RIGHT_TO_WORK_REQUESTS_FILTER', filter);
		},
		setRightToWorkRequestsPage: ({ commit, state }, page) => {
			const $skip = (page - 1) * state.rightToWorkRequestsPagination.$limit;
			commit('SET_RIGHT_TO_WORK_REQUESTS_PAGINATION', { $skip });
			commit('SET_RIGHT_TO_WORK_REQUESTS_FILTER', { $skip });
		},
		updateRightToWorkRequest: async ({ rootGetters }, request) => {
			const url = '/api/v3/righttoworkrequests'; // trust-admin
			const results = await feathersClient.service(url).patch(request.id, request, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		loadRightToWorkRequests: async ({ commit, state, rootGetters }, filter) => {
			delete filter.jobTitle;
			delete filter.band;
			const results = await feathersClient.service('/api/v3/righttoworkrequests').find({
				query: {
					isManager: false,
					status: state.currentStatusPage,
					$role: rootGetters.currentUserRole,
					$populate: { user: 1 },
					...filter,
					'user.verified': true,
					'user.deleted': true,
					$sort: { createdAt: -1 },
				},
			});
			commit('SET_RIGHT_TO_WORK_REQUESTS', results.data);
			const totalCount = results.total;
			commit('SET_RIGHT_TO_WORK_REQUESTS_PAGINATION', { total: totalCount });
			return results.data;
		},
		getNurseUsers: async({ commit, rootGetters }, filter) => {
			const url = '/api/v3/users'; // shift manager
			const results = await feathersClient.service(url).find({ query: { $getNurseUser: true, $role: rootGetters.currentUserRole, ...filter } });
			commit('SET_RIGHT_TO_WORK_REQUESTS', results.data);
			const totalCount = results.total;
			commit('SET_RIGHT_TO_WORK_REQUESTS_PAGINATION', { total: totalCount });
			return results.data;
		},
		createRightToWorkRequest: async ({ rootGetters }, request) => {
			const url = '/api/v3/righttoworkrequests'; // trust-admin
			const results = await feathersClient.service(url).create(request, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		getUserApprovedLevels: async(context, id) => {
			const response = await feathersClient.service('api/v3/user-role-approved-level').find({
				query: {
					userId: id,
					roleType: 'BANK-OFFICER-MANAGER',
					status: 'APPROVED',
				},
			});
			return response.data;
		},

		
        getUserApprovedLevelsRemovedAssignments: async(context, id) => {
			const response = await feathersClient.service('api/v3/user-role-approved-level').find({
				query: {
					userId: id,
					roleType: 'BANK-OFFICER-MANAGER',
					status: 'DECLINED',
				},
			});
			return response.data;
		},
		createTrustContractedHours: async ({ rootGetters }, data) => {
			const url = '/api/v3/trust-staff-contracted-hours'; // trust-admin
			const results = await feathersClient.service(url).create(data,{
				query:{
					$role: rootGetters.currentUserRole,
				}
			});
			return results;
		},
	},
};
